// extracted by mini-css-extract-plugin
export default {"paginationContainer":"pagination_paginationContainer__5I3On"};